/* Gadget Mint — Product page: live visitor counter.
   Purely cosmetic client-side number, no API/network calls, no external
   libraries. Random count re-rolled on a random interval and swapped in
   with a short opacity fade so it never causes layout shift. */
(function () {
  var el = document.querySelector('[data-visitor-counter]');
  if (!el) return;

  var countEl = el.querySelector('[data-visitor-count]');
  if (!countEl) return;

  var MIN_COUNT = 20;
  var MAX_COUNT = 40;
  var MIN_DELAY_MS = 20000;
  var MAX_DELAY_MS = 40000;

  function randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function setCount(value) {
    countEl.classList.add('is-fading');
    window.setTimeout(function () {
      countEl.textContent = value;
      countEl.classList.remove('is-fading');
    }, 200);
  }

  function scheduleNext() {
    window.setTimeout(function () {
      setCount(randomBetween(MIN_COUNT, MAX_COUNT));
      scheduleNext();
    }, randomBetween(MIN_DELAY_MS, MAX_DELAY_MS));
  }

  countEl.textContent = randomBetween(MIN_COUNT, MAX_COUNT);
  scheduleNext();
})();
